import i18n from "../i18n";
import {
  ApiErrorResponseWithMessage,
  ApiErrorResponseWithMessageFromJSON,
  ResponseError
} from "../api_client";


const getErrorMessage =
  (o: ApiErrorResponseWithMessage): string | undefined => {

    let result: string | undefined;
    // Пример с использованием типизации и payload
    // if (isArgumentIsRequiredBadRequestException(o)) {
    //   result = `Аргумент обязателен: ${o.payload.argumentName}`;
    // }
    if (!!o.errorName && i18n.exists(o.errorName, {ns: "apiExceptions"})) {
      result = i18n.t(o.errorName, {ns: "apiExceptions", ...o});
    } else if (!!o.message) {
      console.debug(`Не найдена локализация для ошибки: ${o.errorName}. Отображаю сообщение сервера ${o.message}`, o);
      result = o.message;
    }
    return result;
};

const tryParseApiError = async (e: unknown): Promise<string | undefined> => {
  if (e instanceof ResponseError) {
    try {
      const jsonError = await e.response.clone().json();
      if (typeof jsonError === "string") {
        return jsonError;
      }

      const typedApiError = ApiErrorResponseWithMessageFromJSON(jsonError);
      const message = getErrorMessage(typedApiError);
      if (message) {
        return message;
      }
    } catch {
      // fallback to plain text body
    }

    const textError = await e.response.clone().text();
    if (!textError) {
      return undefined;
    }

    try {
      const parsed = JSON.parse(textError);
      if (typeof parsed === "string") {
        return parsed;
      }
    } catch {
      return textError;
    }
  }

  if (e instanceof Error && e.message) {
    return e.message;
  }

  return undefined;
};

export default tryParseApiError;
